import { useCookies } from 'react-cookie';

export const useCookiesLogin = () => {
  const [cookies, setCookies, removeCookie] = useCookies(['AUTH_TOKEN']);
  return { cookies, setCookies, removeCookie };
};
